module.exports = __webpack_public_path__ + "media/fonts/atlasPro/AtlasProAAA-Regular-a20c08ee18c17a4df827be2db1a41dbe.ttf";